<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Pegawai Internal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "NIP",
        name: "u_nip",
      },
      {
        width: "auto",
        label: "Nama",
        name: "nama",
      },
      {
        width: "auto",
        label: "Unit",
        name: "u_namaunit1",
      },
      {
        width: "auto",
        label: "Jabatan",
        name: "jabatan",
      },
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Pegawai Internal",
      items: [
        {
          text: "Master",
          href: "/",
        },
        {
          text: "Pegawai Internal",
          active: true,
        },
      ],
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "u_nip",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        nip: "",
        nama: "",
        unit: "",
        jabatan: "",
        column: "u_nip",
        dir: "asc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      isSyncing: false,
      syncProgress: 0,
      syncModal: false,
    };
  },
  mounted() {
    this.filterData = _.debounce(this.getTableData.bind(this), 500);
    this.getTableData();
  },
  methods: {
    async getTableData(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/pegawai-internal",
        params: this.tableFilter,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getTableData(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    async syncData() {
      this.isSyncing = true;
      this.syncModal = true;
      this.syncProgress = 0;
      let currentPage = 1;
      let isComplete = false;

      try {
        while (!isComplete) {
          const response = await axios.get(
            `${process.env.VUE_APP_BACKEND_URL_VERSION}sync-dapeg?page=${currentPage}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.access_token}`,
              },
            }
          );

          const { totalPage, page, isComplete: done } = response.data.data;
          isComplete = done;
          this.syncProgress = Math.round((page / totalPage) * 100);
          currentPage++;
        }

        await this.getTableData();
        Swal.fire({
          icon: "success",
          title: "Sinkronisasi Selesai",
          text: "Data pegawai berhasil disinkronkan.",
        });
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Gagal melakukan sinkronisasi data!",
        });
      } finally {
        this.isSyncing = false;
        this.syncModal = false;
      }
    },
    exportExcel() {
      const params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        `${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/pegawai-internal?${params}`,
        "_blank"
      );
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="text-end">
                  <button
                    type="button"
                    class="btn btn-success btn-sm me-2"
                    @click="exportExcel"
                  >
                    <i class="mdi mdi-file-excel me-1"></i> Export Excel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm me-2"
                    @click="syncData"
                    :disabled="isSyncing"
                  >
                    <i class="mdi mdi-sync me-1"></i> Sinkron Data
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3">
                <label for="filterNIP">NIP</label>
                <input
                  type="text"
                  id="filterNIP"
                  class="form-control"
                  placeholder="Filter NIP"
                  v-model="tableFilter.nip"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="filterNama">Nama</label>
                <input
                  type="text"
                  id="filterNama"
                  class="form-control"
                  placeholder="Filter Nama"
                  v-model="tableFilter.nama"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="filterUnit">Unit</label>
                <input
                  type="text"
                  id="filterUnit"
                  class="form-control"
                  placeholder="Filter Unit"
                  v-model="tableFilter.unit"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="filterJabatan">Jabatan</label>
                <input
                  type="text"
                  id="filterJabatan"
                  class="form-control"
                  placeholder="Filter Jabatan"
                  v-model="tableFilter.jabatan"
                  @input="filterData"
                />
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td>{{ index + pagination.from }}</td>
                    <td>{{ row.u_nip }}</td>
                    <td>{{ row.nama }}</td>
                    <td>{{ row.u_namaunit1 }}</td>
                    <td>{{ row.jabatan }}</td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="syncModal"
      hide-footer
      title="Sinkronisasi Data Pegawai"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <div class="progress mb-4">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated"
          role="progressbar"
          :style="{ width: syncProgress + '%' }"
          :aria-valuenow="syncProgress"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {{ syncProgress }}%
        </div>
      </div>
      <p class="text-center">
        Sedang melakukan sinkronisasi data, jangan tutup halaman ini.
      </p>
    </b-modal>
  </Layout>
</template>

<style scoped>
.progress {
  height: 20px;
}
.progress-bar {
  font-size: 12px;
  line-height: 20px;
  color: black;
  font-weight: bold;
}
</style>